import { OnInit, Directive, Input, Renderer2, ElementRef, ViewContainerRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

import { GridStateControlsComponent } from '../components/gridState.component';

@Directive({
    selector: '[gridState]'
})
export class GridStateDirective implements OnInit {
    @Input() gridState;
    @Output() clearFilters = new EventEmitter<void>();

    constructor(
        private viewContainerRef: ViewContainerRef,
        private targetEl: ElementRef,
        private renderer: Renderer2,
        private changeDetector: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        setTimeout(() => {
            const div = this.renderer.createElement('div');
            this.renderer.insertBefore(this.targetEl.nativeElement.parentElement, div, this.targetEl.nativeElement);
            const componentRef = this.viewContainerRef.createComponent(GridStateControlsComponent);
            componentRef.instance.gridState = this.gridState;
            
            componentRef.instance.clearFilters.subscribe(() => {
                this.clearFilters.emit();
            });

            setTimeout(() => {
                this.targetEl.nativeElement.parentElement.replaceChild(
                    componentRef.instance.elementRef.nativeElement,
                    div
                );
                this.changeDetector.markForCheck();
            }, 100);
        }, 100);
    }
}
